import moment from 'moment'

export const COMPANY_NAME = 'CÔNG TY TNHH KTS BÌNH MINH'
export const WAREHOUSE_NAME = 'KHO BÌNH MINH'
export const DEPARTMENT_NAME = 'KHO'
export const DEFAULT_REASON = 'Xuất gia công may'
export const DEFAULT_UNIT = 'Cái'
export const PRINT_DATETIME_FORMAT = 'HH:mm DD/MM/YYYY'
export const EMPTY_VALUE = '........................'

// Class gắn lên body khi đang ở màn in, để CSS @media print chỉ ẩn header của app ở màn này.
export const PRINTING_BODY_CLASS = 'SewingHandoverPrinting'

// Giới hạn độ dài khớp với 3d-api (SewingHandoverActions/print.js).
export const PRINT_INFO_MAX_LENGTH = {
    receiver_name: 100,
    receiver_phone: 50,
    receiver_address: 500,
    reason: 255,
}

// Đã in lần nào thì lấy thông tin in lần trước của phiếu; chưa in thì lấy người nhận chụp lúc giao.
export const getInitialPrintInfo = (handover) => {
    const { print_info: printInfo, receiver, reason } = handover || {}

    if (printInfo) {
        return {
            receiver_name: printInfo.receiver_name || '',
            receiver_phone: printInfo.receiver_phone || '',
            receiver_address: printInfo.receiver_address || '',
            reason: printInfo.reason || reason || DEFAULT_REASON,
        }
    }

    const { name, phone, address } = receiver || {}

    return {
        receiver_name: name || '',
        receiver_phone: phone || '',
        receiver_address: address || '',
        reason: reason || DEFAULT_REASON,
    }
}

// Nhãn nguồn thông tin người nhận trên form: lần in trước (nếu đã in) hoặc đối tác chụp lúc giao.
export const getPrintInfoSource = (handover) => {
    const { print_info: printInfo, last_printed_at: lastPrintedAt, handed_at: handedAt } = handover || {}

    if (printInfo) {
        return lastPrintedAt ? `Lấy từ lần in trước ${moment(lastPrintedAt).format('HH:mm DD/MM')}` : 'Lấy từ lần in trước'
    }

    return handedAt ? `Lấy từ Đối tác lúc giao ${moment(handedAt).format('HH:mm DD/MM')}` : 'Lấy từ Đối tác lúc giao'
}

export const formatPrintDateTime = (value) => value ? moment(value).format(PRINT_DATETIME_FORMAT) : ''

export const formatSlipDate = (value) => {
    if (!value) return ''
    const date = moment(value)

    return `Ngày ${date.format('DD')} tháng ${date.format('MM')} năm ${date.format('YYYY')}`
}

// TỔNG CỘNG tính từ chính các dòng in trên phiếu để luôn khớp với bảng.
export const getSlipTotals = (lines) => {
    const list = lines || []

    return {
        totalBatches: new Set(list.map(line => line.batch_name)).size,
        totalQuantity: list.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0),
    }
}

const CSV_HEADER = ['Số phiếu', 'Ngày giao', 'Đối tác may', 'STT', 'Tên sản phẩm (mã SKU)', 'Tên lô', 'ĐVT', 'Số lượng']

const _escapeCsvCell = (value) => {
    const str = `${value === undefined || value === null ? '' : value}`
    return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}

// CSV phiếu xuất kho: mỗi lô 1 dòng, lặp lại số phiếu / ngày giao / đối tác để lọc, gộp trên Excel.
// ĐVT dùng cùng fallback với phiếu in để file khớp bảng trên phiếu.
export const buildSlipCsv = (handover) => {
    const { code, handed_at: handedAt, partner_snapshot: partner, lines } = handover || {}
    const partnerName = (partner && partner.name) || ''
    const handedAtText = formatPrintDateTime(handedAt)

    const rows = (lines || []).map((line, index) => [
        code, handedAtText, partnerName, index + 1,
        line.product_name, line.batch_name, line.unit || DEFAULT_UNIT, line.quantity,
    ])

    return [CSV_HEADER, ...rows].map(row => row.map(_escapeCsvCell).join(',')).join('\n')
}
